<!-- eslint-disable -->
<template lang="pug">
    tr.points__tr--border
        td.points__td(v-if="user.type !== 'student'")
            router-link.points__link(
                :to="{\
                    name: 'user:profile',\
                    params: {\
                        id: record.user.id,\
                        type: record.user.type\
                    }\
                }"
            )
                | {{ record.user.fullName }}
        td.points__td {{ record.createdAt | moment('DD.MM.YYYY') }}
        td.points__td(:class="points > 0 ? 'points__positive' : 'points__negative'") {{ +points }}
        td.points__td
            template(v-if="isModel(record, 'User')")
                router-link.points__link(
                    v-if="user.type !== 'student'"
                    :to="{\
                        name: 'user:profile',\
                        params: {\
                            id: record.source.id,\
                            type: record.source.type\
                        }\
                    }"
                )
                    | {{ record.source.fullName }}
                span(v-else) {{ record.source.fullName }}
            template(v-else-if="isModel(record, 'ExerciseStat')")
                router-link.points__link(
                    v-if="record.source && record.gameExercise && record.gameExercise.source && record.gameExercise.sourceType === 'homework'"
                    :to="{ name: 'homework:edit', params: { id: record.gameExercise.sourceId } }"
                )
                    | {{ sourceName }}
                span(v-else-if="record.source")
                    | {{ sourceName }}
                span(v-else)
                    | {{ $i18n.t('historyTable.historyTable_preview_homeworkDeleted') }}
            router-link.points__link(
                v-else-if="isModel(record, 'City')"
                :to="{\
                    name: 'map',\
                    params: {\
                        modal: true,\
                        location: record.source.name\
                    }\
                }"
            )
                | {{ $i18n.t('historyTable.historyTable_preview_travel') }}
                | {{ $i18n.t('mapModal.locationsWithPretext')[record.source.name] }}
</template>

<script>
    /*eslint-disable*/
    import {mapState} from 'vuex';
    import {camelCase} from 'lodash';

    export default {
        props: {
            record: Object
        },
        computed: {
            ...mapState({
                user: state => state.auth.user
            }),
            points () {
                return this.record.points > 0 ? `+${this.record.points}` : this.record.points;
            },
            sourceName () {
                let mode = '';
                if (!this.record.source) {
                    return mode;
                }
                if (this.record.olympiadId) {
                    mode = this.$i18n.t('points.points_preview_olympiad') + this.record.olympiad.name + ': ';
                } else if (this.record.gameExerciseId) {
                    if (this.record.gameExercise && this.record.gameExercise.sourceDate) {
                        let homeworkDate = this.$moment(this.record.gameExercise.sourceDate).format('DD.MM.YYYY');
                        mode = this.$i18n.t('points.points_preview_homework') + homeworkDate + '): ';
                    } else {
                        if (!this.record.gameExercise) {
                            mode = this.$i18n.t('points.points_preview_trainerExerciseDeleted');
                        } else if (!this.record.gameExercise.sourceDate) {
                            mode = !this.record.battleStart ? this.$i18n.t('battle.battle_layout_training') : this.record.battleName;
                            mode += ': ';
                        }
                    }
                } else {
                    mode = this.$i18n.t('points.points_preview_freeGame');
                }
                if (this.record.gameExercise && this.record.gameExercise.sourceType === 'olympiadLevelTrainerStage') {
                    mode = this.$i18n.t('points.points_preview_freeGame');
                }
                const name = this.$i18n.t(`common.common_gameName_${camelCase(this.record.source.game)}`);
                return mode + name;
            }
        },
        methods: {
            isModel(record, type) {
                return record.sourceType === 'App\\Models\\' + type;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .points__td {
        padding: 13px 8px;
        @include media($md) {
            padding: 10px 20px;
        }
        @include media($lg) {
            padding: 10px 30px;
        }
    }

    .points__tr--border {
        border-bottom: 1px solid #E6E6F8;
    }

    .points__link {
        white-space: nowrap;
        color: $hsl-color-blue-56;
        text-decoration: underline;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }

    .points__positive {
        color: $hsl-color-green-58;
    }

    .points__warning {
        color: $hsl-color-yellow-66;
    }

    .points__negative {
        color: $hsl-color-red-62;
    }
</style>
